module.exports = __webpack_public_path__ + "static/media/slide1.2bcb857c.jpg";